export const ideaPageConstants = {
    deletedUser:"deleted.user"
}